import DatePicker from 'vue2-datepicker';
export default {
  name: 'invoiceLineDetails',
  props: ['headerId'],
  components: { DatePicker },
  data() {
    return {
      loader:false,
      billfromName: null,
      billFromGstn: null,
      billToName: null,
      billToGstn: null,
      invoiceDate: null,
      invoiceNumber: null,
      poNumber: null,
      pan: null,
      baseAmount: null,
      taxAmount: null,
      totalAmount: null,
      invoiceLineData: [],
      invoiceLineields: [
        {
          key: 'item',
          label: 'Item',
          class: 'col-fix-item text-left'
        },
        {
          key: 'unit_price',
          label: 'Unit Price',
          class: 'col-fix-amount text-right'
        },
        {
          key: 'quantity',
          label: 'Quantity',
          class: ' col-fix-amount text-right'
        },
        {
          key: 'hsn_code',
          label: 'HSN/SAC Code',
          class: 'col-fix-amount text-center'
        },
        {
          key: 'line_tax_amount',
          label: 'Tax Amount',
          class: 'col-fix-amount text-right'
        },
        {
          key: 'total_price',
          label: 'Taxable Price',
          class: ' col-fix-amount text-right'
        },
        {
          key: 'amount',
          label: 'Amount',
          class: 'col-fix-amount text-right'
        }
      ]
    };
  },
  mounted() {
    this.getInvoiceDetailsDataById();
  },
  methods: {
    getInvoiceDetailsDataById() {
      const payload = {
        id: this.headerId
      };
      this.loader = true;
      this.$store
        .dispatch('invoiceDetails/getInvoiceDetailsDataById', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            const result = response.data.data;
            this.autoFillHeaderData(result);
          }
        });
    },
    autoFillHeaderData(result) {
      (this.billfromName = result.bill_from_name),
        (this.billFromGstn = result.bill_from_gstin),
        (this.billToName = result.bill_to_gstin),
        (this.billToGstn = result.bill_to_name),
        (this.invoiceDate = result.invoice_date),
        (this.invoiceNumber = result.invoice_number),
        (this.poNumber = result.purchase_order_no),
        (this.pan = result.pan_no),
        (this.baseAmount = result.base_amount);
      (this.taxAmount = result.tax_amount),
        (this.totalAmount = result.total_amount);
      this.invoiceLineData = result.inv_dtl;
      for (let i of this.invoiceLineData) {
        i.amount = +i.line_tax_amount + +i.total_price;
      }
    }
  }
};
